module.exports = __webpack_public_path__ + "img/saveBtn.35c536de.png";